import React, { useState, useRef, useEffect, useCallback } from "react";
import FeedbackQrFilter from "./FeedbackQrFilter";

const FeedbackQr = () => {
    return (
        <div className="w-full sm:w-12/12 px-28">
            <FeedbackQrFilter />
        </div>
    )
}

export default FeedbackQr;